/**
 *

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type NullEnum = null;

export const NullEnum = {} as const;
